import { SEARCH_SECTION_FROM } from "@faire/help-center-utils/consts/eventEnum";
import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useCustomerType } from "@faire/help-center-utils/hooks/useCustomerType";
import { useStrictLocalization } from "@faire/web--source/common/localization";

import { useIsSearchInputAtHeader } from "./useIsSearchInputAtHeader";

export const useSearchInputPlaceholder = (
  sectionFrom?: SEARCH_SECTION_FROM
) => {
  const { customerType } = useCustomerType();
  const { strictLocalize } = useStrictLocalization();
  const isSearchInputAtHeader = useIsSearchInputAtHeader(sectionFrom);
  if (isSearchInputAtHeader) {
    return strictLocalize({
      defaultMessage: "Search",
      description: {
        text: "Placeholder for the search input field in the header",
      },
    });
  }
  return customerType === CustomerTypes.BRAND
    ? strictLocalize({
        defaultMessage: "Search brand guides",
        description: {
          text: "Placeholder for the search input field in the help center",
          img: "https://cdn.faire.com/fastly/d498b624bffa40b5c692e2ed97b5afd379deac1fc8ee290d3c3299096195ccc6.png",
        },
      })
    : strictLocalize({
        defaultMessage: "Search retailer guides",
        description: {
          text: "Placeholder for the search input field in the help center",
          img: "https://cdn.faire.com/fastly/d498b624bffa40b5c692e2ed97b5afd379deac1fc8ee290d3c3299096195ccc6.png",
        },
      });
};
